import { AxiosInstance } from 'axios';
import {
  NoteEndpoints,
  CreateNoteRequest,
  CreateNoteResponse,
  GetNotesRequest,
  GetNotesResponse,
} from './NoteServices.types';

export class NoteServices implements NoteEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(request: CreateNoteRequest) {
    return this.instance.post<CreateNoteResponse>(
      `/order/${request.routeParams.orderGuid}/note`,
      request.body,
    );
  }

  get(request: GetNotesRequest) {
    return this.instance.get<GetNotesResponse>(`/order/${request.routeParams.orderGuid}/notes`, {
      params: request.queryParams,
    });
  }
}
